import { BaseError } from "./base-error";

export class ClientError extends BaseError {
    constructor(msg: string, status: string, severity: string = 'error') {
        super(msg);
        this.type = 'ClientError';
        this.status = 'CLIENT:' + status;
        this.severity = severity;
    }

    static Cookie() {
        return new ClientError("Keks is not available.", "COOKIE");
    }

    /** The stored HTML content of a studio document could not be downloaded. */
    static DocumentContentLoad() {
        return new ClientError("Document content could not be loaded.", "DOCUMENT_CONTENT_LOAD");
    }

    /** A file download (e.g. a URL from `__files`) answered with a non-ok HTTP status. */
    static FileLoad(status: number) {
        const e = new ClientError(`File could not be loaded (${status}).`, "FILE_LOAD");
        e.args = { status };
        return e;
    }
}
